import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import axios from "axios";
import BASE_URL from '../config';
const CoursePage = () => {
  const [courses, setCourses] = useState([]);
  const [courseName, setCourseName] = useState("");
  const [academicType, setAcademicType] = useState("");
  const [editId, setEditId] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState('');
  const navigate = useNavigate();
  // Fetch courses from API
  useEffect(() => {
    const storedName = sessionStorage.getItem('adminName');
    if (!storedName) {
      navigate('/admin/login'); // Redirect if no admin is logged in
  } else {
    setLoggedInUser(storedName); // Set admin name
  }
    
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/course`);

      const formattedCourses = response.data.map((course) => {
        const date = new Date(course.CreatedDate);
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
        return { ...course, CreatedDate: formattedDate };
      });

      setCourses(formattedCourses);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const handleAddOrUpdate = async () => {
    if (!courseName || !academicType) {
      alert("Please fill all fields.");
      return;
    }
  
    const payload = {
      CourseName: courseName,
      AcademicType: academicType,
      CreatedBy: loggedInUser,
      CreatedDate: new Date().toISOString().split("T")[0],
    };
  
    try {
      if (editId) {
        // Update course
        await axios.put(`${BASE_URL}/api/course/${editId}`, payload);
        alert("Course updated successfully.");
      } else {
        // Add course
        await axios.post(`${BASE_URL}/api/course`, payload);
        alert("Course added successfully.");
      }
      setCourseName("");
      setAcademicType("");
      setEditId(null);
      fetchCourses();
    } catch (error) {
      if (error.response && error.response.status === 400) {
        alert(error.response.data); // Show duplicate course error
      } else {
        console.error("Error adding/updating course:", error);
      }
    }
  };

  const handleEdit = (course) => {
    setCourseName(course.CourseName);
    setAcademicType(course.AcademicType);
    setEditId(course.CourseID);
     // Scroll to the top of the page
 /*  window.scrollTo({
    top: 0,
    behavior: "smooth",
  }); */
   //window.scrollTo({ top: 0, behavior: "smooth" });
   const container = document.querySelector('#root');
   container.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/api/course/${id}`);
      alert("Course deleted successfully.");
      fetchCourses();
    } catch (error) {
      console.error("Error deleting course:", error);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h4" mb={2}>
        Manage Courses
      </Typography>

      <Box
        display="flex"
        gap={2}
        flexWrap="wrap"
        mb={3}
        alignItems="center"
      >
        <TextField
          label="Course Name"
          variant="outlined"
          value={courseName}
          onChange={(e) => setCourseName(e.target.value)}
          fullWidth
        />
        <TextField
          label="Academic Type"
          variant="outlined"
          select
          value={academicType}
          onChange={(e) => setAcademicType(e.target.value)}
          fullWidth
        >
          <MenuItem value="Semester">Semester</MenuItem>
          <MenuItem value="Yearly">Yearly</MenuItem>
        </TextField>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAddOrUpdate}
        >
          {editId ? "Update Course" : "Add Course"}
        </Button>
      </Box>

      <TableContainer component={Paper} >
        <Table
         sx={{
          border: "1px solid #ccc", // Add border to the table
          borderRadius: "8px", // Rounded corners
        }}
        >
          <TableHead
           sx={{
            backgroundColor: "black", // Dark blue background
            "& th": {
              color: "#fff", // White text color for header
              fontWeight: "bold", // Bold text
              fontSize: "16px", // Font size
            },
          }}
          
          >
            <TableRow>
              <TableCell>Course Name</TableCell>
              <TableCell>Academic Type</TableCell>
              <TableCell>Created By</TableCell>
              <TableCell>Created Date</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {courses.map((course) => (
              <TableRow key={course.CourseID}>
                <TableCell>{course.CourseName}</TableCell>
                <TableCell>{course.AcademicType}</TableCell>
                <TableCell>{course.CreatedBy}</TableCell>
                <TableCell>{course.CreatedDate}</TableCell>
                <TableCell>
                  <IconButton
                    color="primary"
                    onClick={() => handleEdit(course)}
                  >
                    <Edit />
                  </IconButton>
                  <IconButton
                    color="secondary"
                    onClick={() => handleDelete(course.CourseID)}
                  >
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CoursePage;
